import { PROFILE_PREFIX } from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { useNavigate } from 'react-router-dom';
import DocumentUploadReminderInformPopup from './popup';

const DocumentUploadReminderInformModal = ({ isShow }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();
  const navigate = useNavigate();
  const { isDesktop } = useDetectDevice();

  const handleOnClick = () => {
    if (isDesktop) {
      navigate(`${PROFILE_PREFIX}?isUploadDocumentsTrigger=true`);
    } else {
      navigate(`${PROFILE_PREFIX}?tab=0&isUploadDocumentsTrigger=true`);
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    closePortalModalName();
  };

  return (
    <DocumentUploadReminderInformPopup
      isOpen={isShow}
      buttonLabel1={t('button_later')}
      onClose={handleOnClose}
      buttonLabel2={t('button_upload_now')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default DocumentUploadReminderInformModal;
